import type { Account } from '@shared/products-types';
import type { GetCustomizationResponse } from '@api-client/products';
import { logger } from '@luna/logger';
import { useActiveProduct } from '@shared/products-core';

import { gAPIAccountEntitySlice } from '../../../../gAPIAccountEntitySlice';

export const useCustomizationSuccessHandler = () => {
    const { id } = useActiveProduct<Account>();

    const gapiAccount = gAPIAccountEntitySlice.selectById(id);

    return (customizationResponse: GetCustomizationResponse) => {
        const customizationView = customizationResponse._embedded?.['customization-view'];

        if (!customizationView) {
            logger.error('missing customization-view object in response');
            return;
        }

        gAPIAccountEntitySlice.updateCache({
            ...gapiAccount,
            alias: customizationView.name,
            additionalData: {
                ...gapiAccount?.additionalData,
                hidden: customizationView.hiddenOnOverview,
                color: customizationView.color.id ?? '',
            } as Account['additionalData'],
        } as Account);
    };
};
